export default () => ({
  actieLogs: [],
  loginLogs: [],
  inzageLogs: [],
  users: []
});
